import {
  useState,
} from 'react';

export const DEFAULT_Z_INDEX = 'DEFAULT_Z_INDEX';

export type PromotableZIndex = typeof DEFAULT_Z_INDEX | number;

interface Input {
  promotedZIndex: number;
  numElements: number;
}
export default (input: Input) => {
  const {promotedZIndex, numElements} = input;
  type ZIndexRegister = Array<typeof DEFAULT_Z_INDEX | number>;
  const initialArray: ZIndexRegister = [];
  for (let i = 0; i < numElements; i += 1) {
    initialArray.push(DEFAULT_Z_INDEX);
  }
  const [zIndices, setZIndices] = useState<ZIndexRegister>(initialArray);
  const promoteZIndex = (elementIndex: number) => setZIndices((currentIndices: ZIndexRegister) => {
    const result: ZIndexRegister = [];
    for (let i = 0; i < currentIndices.length; i += 1) {
      const newZIndex = (i === elementIndex) ? promotedZIndex : DEFAULT_Z_INDEX;
      result.push(newZIndex);
    }
    return result;
  });
  const restoreZIndex = (elementIndex: number) => setZIndices((currentIndices: ZIndexRegister) => {
    const copy = [...currentIndices];
    copy[elementIndex] = DEFAULT_Z_INDEX;
    return copy;
  });
  const getZIndex = (elementIndex: number) => zIndices[elementIndex];

  return {
    promoteZIndex, restoreZIndex, getZIndex,
  };
};
